import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { ProjetoProduto } from '../models/projeto-produto.model';
import { Observable } from 'rxjs';

@Injectable()
export class ProjetoProdutoService extends BaseService<ProjetoProduto> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getFilters(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list-filters', { headers: this.headers });
  }

  public getProdTemplate(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list-prod-template/' + id, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/pre-projeto/projeto-produto';
  }
}
